// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import axiosConfig from './service/config'
import store from './store';
import params from '../config/params'
import Vuex from 'vuex';
Vue.use(Vuex);
Vue.use(MintUI)
Vue.config.productionTip = false
Vue.prototype.params = params
//路由退出
router.afterEach((to, from) => {
 window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js